export default __webpack_public_path__ + "static/media/testimony_teacher_four.258cdd33.png";